import axios from '@axios';
import HelperService from './HelperService';

const helperService = new HelperService();
const baseUrl = '/api/v1/feedback';
const baseUrlPrisoner = '/api/v1/prisoner-feedback';



export default {
  getPrisonerFeedbackLeaderboard(filters) {
    const queryString = helperService.buildSearchQueryString(filters);
    return axios.get(`${baseUrlPrisoner}/stats/average/leaderboard${queryString}`);
  },
  getPrisonerFeedbackStatsAverage(filters) {
    const queryString = helperService.buildSearchQueryString(filters);
    return axios.get(`${baseUrlPrisoner}/stats/average${queryString}`);
  },
  getFeedbackLeaderboard(filters) {
    const queryString = helperService.buildSearchQueryString(filters);
    return axios.get(`${baseUrl}/stats/average/leaderboard${queryString}`);
  },
  getFeedbackStatsAverage(filters) {
    const queryString = helperService.buildSearchQueryString(filters);
    return axios.get(`${baseUrl}/stats/average${queryString}`);
  },
};
